export default __webpack_public_path__ + "files/Data Resource Button-9bb367b755602fb063c995428fe75331.png";